<template>
  <v-dialog v-model="rescheduleNbnAppointment" width="500" persistent>
    <v-card class="pb-4">
      <v-card-title class="primary">
        <span class="white--text">Reschedule NBN Appointment</span>
      </v-card-title>
      <v-card-text class="subtitle-1 pb-0 pt-3">
        <b class="mb-2">Current Appointment Date:</b>
        {{ appointmentData.appointmentSlot.validFor.startDateTime }}<br />
      </v-card-text>

      <v-card-actions class="mt-4">
        <v-row
          align="center"
          justify="center"
        >
          <!-- Date Picker -->
          <v-col class="d-flex justify-center">
            <ValidationProvider
              name="Start DateTime"
              :rules="'required'"
              v-slot="{ errors }"
            >
              <v-date-picker
                v-model="dateTimeRange"
                type="date"
                range
                no-title
                :min="today"
              ></v-date-picker>
            </ValidationProvider>
          </v-col>
        
          <!-- Button -->
          <v-col class="d-flex justify-center">
            <v-btn
              class="primary"
              @click="checkSlot"
            >
              Check Slot
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>

      <div v-if="showSlots" class="px-4">
        <b>Available Slots:</b>

        <v-radio-group v-model="dateGroup" class="mt-0 pl-3 slot-list">
          <v-radio
            v-for="slot in availableNbnSlots"
            :key="slot.validFor.startDateTime"
            :label="formatSlot(slot.validFor.startDateTime)"
            :value="slot"
          ></v-radio>
          <span v-if="showNote" class="red--text font-italic">No available time slots</span>
        </v-radio-group>
      </div>

      <v-divider></v-divider>

      <v-card-actions class="mt-4">
        <v-spacer></v-spacer>
        <v-btn
          class="primary mr-2"
          @click="$emit(`processNbnReschedule`, dateGroup)"
        >Reschedule</v-btn
        >
        <v-btn class="mr-4" @click="closeRescheduleDialog">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
  name: "reschedule-nbn-appointment",
  components: { DatePicker },
  props: {
    rescheduleNbnAppointment: {
      type: Boolean,
      required: true,
    },
    appointmentData: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    dateGroup: null,
    availableNbnSlots:[],
    dateTimeRange:null,
    showSlots:false,
    today: new Date().toISOString().substr(0, 10),
    showNote: false
  }),
  methods:{
    checkSlot(){
      let vm = this;
      let payload = {};
      payload = {
        locationId:vm.appointmentData.place.id,
        demandType:vm.appointmentData.demandType,
        priId:null,
        alternativeTechnology:null,
        appointmentId:null,
        copperPairId:null,
        appointmentSLA:vm.appointmentData.appointmentSLA,
        appointmentSlotType:vm.appointmentData.appointmentSlotType,
        priorityAssist:"No",
        nBNReferenceID:null,
        startDateTime:vm.dateTimeRange[0],
        endDateTime:vm.dateTimeRange[1]
      };

      if(vm.featureFlags?.sog8475){
        if (payload.startDateTime) {  
          var start = new Date(payload.startDateTime);
          var end = payload.endDateTime
              ? new Date(payload.endDateTime)
              : new Date(payload.startDateTime);
              
          // swap if needed
          if (end < start) {
              [start, end] = [end, start];
          }
        
          const formatDateOnly = (date) => {
              const pad = (n) => String(n).padStart(2, '0');
          
              return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
          };
        
          payload.startDateTime = formatDateOnly(start);
          payload.endDateTime = formatDateOnly(end);
        }

        vm.checkNbnAllAvailableSlots(payload).then((data) => {
          vm.showSlots = true;
          vm.availableNbnSlots = data.data.availableTimeSlot;
          vm.showNote = vm.availableNbnSlots?.length === 0;
        });
      } else {
        vm.checkNbnAvailableSlots(payload).then((data) => {
          vm.showSlots = true;
          vm.availableNbnSlots = data.data.availableTimeSlot;
        });
      }
    },
    formatSlot(date) {
      const filters = this.$options.filters;
      return this.featureFlags?.sog8475
        ? filters.formatDateTimeNew(date, true)
        : filters.formatDateTime(date, true);
    },
    closeRescheduleDialog(){
      let vm = this;
      vm.dateTimeRange = null;
      vm.showSlots = false;
      vm.availableNbnSlots = [];
      vm.showNote = false;
      vm.$emit(`closeReschedule`);
    }
  }
}
</script>

<style scoped>
.slot-list {
  max-height: 300px;
  overflow-y: auto;
}
</style>
